import './Imgs.css'

import { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { ZoomInOutlined, ZoomOutOutlined, RotateLeftOutlined } from '@ant-design/icons'

import _ from 'lodash'

interface CheckImgsProp {
    tinyURL: string[],
    visible: boolean

    onCancel: () => void
}

const CheckImgs = (props: CheckImgsProp) => {

    let initWidth: number = 400
    let { visible, onCancel, tinyURL } = props

    const [bigImgUrl, setBigImgUrl] = useState<string>('')
    const [index, setIndex] = useState<number>(0)
    const [styles, setStyles] = useState<{ width: number, rotate: number }>({ width: initWidth, rotate: 0 })

    const handleTinyChange = (e: any) => {
        if (e.target.src) {
            setIndex(Number(e.target.dataset.index))
            setBigImgUrl(e.target.src)
        }
    }

    useEffect(() => {
        if (visible) {
            let s = _.cloneDeep(styles)

            s.width = initWidth
            s.rotate = 0

            setStyles(s)
        }
    }, [visible])

    useEffect(() => {
        setBigImgUrl(tinyURL[0])
    }, [tinyURL])

    return <Modal zIndex={100} className="img-modal" visible={visible} title="查看图片" width={styles.width} footer={false} maskClosable={false} onCancel={onCancel}>
        <div className="check-imgs" >
            <div className="big-imgs">
                <img src={bigImgUrl} style={{ transform: 'rotate(' + styles.rotate + 'deg)' }} />
            </div>

            <div className="tiny-imgs" onClick={handleTinyChange}>
                {tinyURL.map((el, elIndex) => <img data-index={elIndex} src={el} className={index === elIndex ? 'current' : ''} />)}
            </div>

            <div className="img-func-btns">
                <span><RotateLeftOutlined onClick={() => {
                    let s = _.cloneDeep(styles)
                    s.rotate = s.rotate + 90
                    setStyles(s)
                }} /></span>

                <span><ZoomInOutlined onClick={() => {
                    let s = _.cloneDeep(styles)
                    if (s.width < 1000) {
                        s.width = s.width + 150
                        setStyles(s)
                    }
                }} /></span>

                <span><ZoomOutOutlined onClick={() => {
                    let s = _.cloneDeep(styles)
                    if (s.width > 300) {
                        s.width = s.width - 150
                        setStyles(s)
                    }
                }} /></span>
            </div>
        </div>
    </Modal>
}

export { CheckImgs }